import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_DUPLICATE_CARD, GET_DUPLICATE_CARD_SUCCESS, GET_DUPLICATE_CARD_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getDuplicateCardsList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/duplicate-cards`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_DUPLICATE_CARD_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_DUPLICATE_CARD_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_DUPLICATE_CARD_ERROR, payload: error });
  }
}

export function* watchDuplicateCardsList() {
  yield takeEvery(GET_DUPLICATE_CARD, getDuplicateCardsList);
}

function* getDuplicateCardsListSaga() {
  yield all([fork(watchDuplicateCardsList)]);
}

export default getDuplicateCardsListSaga;
